import React from "react";
import { Link, useLocation } from "react-router-dom";

const routeNames = {
  "": "Главная",
  about: "Об институте",
  history: "История института",
  structure: "Структура института",
  licenses: "Правовая информация и лицензии",
  privacy: "Политика конфиденциальности",
  "anti-corruption": "Противодействие коррупции",
  controls: "Органы управления",
  vacancies: "Вакансии",
  science: "Наука",
  research: "Научно-исследовательские разработки",
  development: "Разработка технологий",
  dissertation: "Диссертационный совет",
  "clinical-trials": "Клинические испытания",
  publications: "Научные публикации",
  assistance: "Лечебно-диагностическая помощь",
  education: "Образование",
  residency: "Ординатура",
  "postgraduate-studies": "Аспирантура",
  additional: "Дополнительное образование",
  clinic: "Клиника",
  hospital: "Высокотехнологичная медицинская помощь",
  "day-hospital": "Дневной стационар",
  consultative: "Консультативное отделение",
  laboratory: "Лаборатория",
  patients: "Пациентам",
  reception: "Прием специалистов",
  "reception-omc": "Прием специалистов ОМС",
  working: "График работы",
  pay: "Платные услуги",
  "prevention-healthy": "Профилактика и ЗОЖ",
  contacts: "Контакты",
  videobroadcast: "Видеотрансляции",
  advertisements: "Объявления о защите кандидатских и докторских диссертаций",
  news: "Новости",
  "working-conditions": "Условия труда",
  "accounting-policy": "Учетная политика",
  "independent-assessment": "Независимая оценка качества",
  "heating-season": "Подготовка к отопительному сезону",
  certification: "Аттестация научных работников",
  "scientific-research": "Научные исследования",
  "working-chief":
    "Работа с главными врачами кожно-венерологических учреждений",
  "problem-syphilis": "Консультативный совет по проблемме сифилис",
  specialists: "Специалисты",
  provision: "Оказание услуг гражданам в сфере здравоохранения",
  "accessible-environment": "Доступная среда",
  helplines: "Телефоны доверия",
  "fire-safety": "Пожарная безопасность",
  "clinical-examination": "Диспансеризация населения",
  gosuslugi: "Госуслуги",
  "tax-deduction": "Налоговый вычет за платные образовательные услуги",
  "advanced-training": "Циклы повышения квалификации",
  "certification-cycle": "Сертификационный цикл",
  "short-improvement": "Краткосрочное тематическое усовершенствование",
  "professional-retraining":
    'Профессиональная переподготовка по специальности "Косметология"',
  "teaching-staff": "Профессорско-преподавательский состав",
  "admissions-committee": "Приемная комиссия",
  "scientific-educational": "Научно - образовательный отдел",
  "educational-program": "Образовательная программа ординатуры",
  "regulatory-documents": "Нормативные документы",
  "organization-monitoring": "Организация мониторинга качества образования",
  "clinical-base": 'Клиническая база ГБУ СО "УрНИИДВиИ"',
  "contingent-students": "Контингент обучающихся в ординатуре: 2018 год",
  "price-list": "Прейскурант",
  "specialized-medical": "Специализированная медицинская помощь",
  malishevskaya: "Малишевская Н.П.",
  zilberberg: "Зильберберг Н.В.",
  kohan: "Кохан М.М.",
  syrneva: "Сырнева Т.А.",
  evstigneeva: "Евстигнеева Н.П.",
  filimonkova: "Филимонкова Н.Н.",
  grekova: "Грекова Ю.Н.",
  keniksfest: "Кениксфест Ю.В.",
  levchik: "Левчик Н.К.",
  surganova: "Сурганова В.И.",
  pazina: "Пазина М.В.",
  elkina: "Елькина М.В.",
  dmitrieva: "Дмитриева М.В.",
  safonova: "Сафонова Г.Д.",
  gerasimova: "Герасимова Н.А.",
  ponomareva: "Пономарева М.В.",
  kasheeva: "Кащеева Я.В.",
  gerasimov: "Герасимов А.А.",
  osipenko: "Осипенко А.В.",
  tenkacheva: "Тенкачева Т.Р.",
  andriyanova: "Андриянова О.В.",
  skidan: "Скидан Н.И.",
  farlenkova: "Фарленкова Е.Ю.",
  orekhov: "Орехов Д.В.",
  gorbunov: "Горбунов А.П.",
  bolshagin: "Большагин С.А.",
  rabtsevich: "Рабцевич В.В.",
  kokorina: "Кокорина Н.С.",
  farina: "Фарина Ю.А.",
  zhitnikovskaya: "Житниковская А.Л.",
  letaeva: "Летаева О.В.",
  polishchuk: "Полищук А.И.",
  nikitina: "Никитина Е.В.",
  filatova: "Филатова Е.С.",
  rimar: "Римар О.Г.",
  popov: "Попов К.С.",
  kargina: "Каргина К.В.",
  zhulimova: "Жулимова Н.Л.",
  dertko: "Дертко М.Е.",
  polyakova: "Полякова Н.В.",
  egorova: "Егорова М.О.",
  week: "Мероприятия по профилактике заболеваний и поддержке здорового образа жизни",
  rasputina: "Распутина Л.Г.",
  nasyrova: "Насырова Л.Ю.",
  grishaeva: "Гришаева Е.В.",
  sitemap: "Карта сайта",
  cabinet: "Личный кабинет",
  participantsSVO: "Участникам СВО",
  kungurov: "Кунгуров Н.В.",
  poteha: "Потеха Ю.В.",
  khudkova: "Худкова А.И.",
  stukova: "Стукова Е.И.",
  chigvintseva: "Чигвинцева Е.А.",
  medvedeva: "Медведева Ю.А.",
  kiseleva: "Киселева Н.В.",
  staff: "Кабинет сотрудника",
  admin: "Админ-панель",
  login: "Вход в личный кабинет",
  register: "Регистрация",
  "anti-terror": "Антитеррористическая безопасность",
  "question-answer": "Вопрос–ответ",
  sokolova: "Соколова А.В.",
  managers: "Руководители",
  services: "Услуги",
  "udalenie-papillom": "Удаление папиллом",
  "emergency-numbers": "Телефоны справочных служб",
  reviews: "Отзывы",
  "new-reviews": "Оставить отзыв",
};

export default function Breadcrumbs() {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  return (
    <nav className="breadcrumbs">
      <Link className="breadcrumbs__link" to="/">
        Главная
      </Link>
      {pathParts.map((part, index) => {
        const path = "/" + pathParts.slice(0, index + 1).join("/");
        const isLast = index === pathParts.length - 1;

        return (
          <span className="breadcrumbs__link" key={path}>
            {" / "}
            {isLast ? (
              <span className="breadcrumbs__link breadcrumbs__link_lost">
                {routeNames[part] || part}
              </span>
            ) : (
              <Link className="breadcrumbs__link" to={path}>
                {routeNames[part] || part}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
